module.exports = __webpack_public_path__ + "static/media/ls-3.b563f164.jpg";